import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Input } from "@angular/core";
import { NavigationExtras, Router, ActivatedRoute, Params } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs';
import { CanComponentDeactivate } from '../services/navigation-gaurd.service';

declare function carouselInit();

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, CanComponentDeactivate {

@Input()
  url: string = "../assets/home.html";
  urlSafe: SafeResourceUrl;
  public mySlideImages;
  public myCarouselImages;
  public mySlideOptions;
  public myCarouselOptions;

  constructor(public sanitizer: DomSanitizer,
   private readonly _activatedRoute: ActivatedRoute,) {


   }

canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    // if( this.registrationForm.dirty) {
    //   return confirm('Form has unsaved changes.' + 
    //   ' Any Data entered will be lost. Do you want to leave?');
    // } else {
    //   return true;
    // }
    return true;
   }

  ngOnInit() {
  
carouselInit();

  this._activatedRoute.params.subscribe((params: Params) => {
      let section: string = params['section'];
      if(section == 'faq') {
        const element = document.querySelector('#faq');
        element.scrollIntoView();
      }
      if(section == 'contact') {
        const element = document.querySelector('#contact');
        element.scrollIntoView();
      }
  });

}
}
